<template>
  <div class="main-login">
    <header class="header-login">
      <div class="logo">
        <img src="../assets/LogoZecon.png" alt="" />
      </div>
      <div class="back-to-site">
        <a href="/" class="site-link">
          <img src="../assets/IconeHome.png" alt="Home" class="home-icon" />
          Voltar ao Site
        </a>
      </div>
    </header>
    <div class="auth-container">
      <h2 class="title-login">Autenticação</h2>
      <form @submit.prevent="login">
        <div class="input-container">
          <input
            type="email"
            id="email"
            v-model="email"
            placeholder="Email"
            required
          />
        </div>
        <div class="input-container">
          <input
            type="password"
            id="password"
            v-model="senha"
            placeholder="Senha"
            required
          />
        </div>
        <button type="submit" class="enviar-button">ENTRAR</button>
      </form>
      <div v-if="authStatus === 'fail'" class="auth-fail">
        Usuário ou senha incorretos.
      </div>
    </div>
    <Bottom class="bottom-fixed" />
  </div>
</template>
  
<script>
import Bottom from "./Bottom.vue";
import { api } from "../services/api/Api.js";

export default {
  name: "Login",
  components: {
    Bottom,
  },
  data() {
    return {
      email: "",
      senha: "",
      authStatus: null,
    };
  },
  methods: {
    async login() {
      const response = await api.post("/login", {
          email: this.email,
          senha: this.senha,
        })
        .then((response) => {
          if (response.data.token) {
            this.authStatus = "success";
            console.log("Autenticação bem-sucedida!");
            localStorage.setItem("token", response.data.token);
            this.$router.push({ name: 'Tabela' });
          } else {
            this.authStatus = "fail";
            console.log("Autenticação falhou!");
          }
        })
        .catch((error) => {
          this.authStatus = "fail";
          console.error("Erro durante a autenticação:", error);
        });

      return response;
    },
  },
};
</script>
  
<style scoped>
.main-login {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  background: radial-gradient(
      20em 20em at 0% 0%,
      #ffb800 0%,
      rgba(37, 37, 37, 0) 100%
    ),
    radial-gradient(
      20em 20em at 100% 100%,
      #ffb800 0%,
      rgba(37, 37, 37, 0) 100%
    ),
    #252525;
}

.header-login {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #343333;
  color: white;
  width: 100%;
  height: 9vh;
  box-sizing: border-box;
  z-index: 1;
}

.logo {
  padding: 0 6vw;
  display: flex;
  align-items: center;
}

.logo img {
  height: 6vh;
}

.back-to-site {
  padding: 0 6vw;
  display: flex;
  align-items: center;
}

.site-link {
  color: #f5f5f5;
  text-decoration: none;
  font-family: "Montserrat", sans-serif;
  font-size: 20px;
  font-weight: 400;
  display: flex;
  align-items: center;
}

.home-icon {
  width: 1em;
  height: 1em;
  margin-right: 0.5em;
}

.auth-container {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 25em;
  height: auto;
  border-radius: 10px;
  transform: translate(-50%, -50%);
  background: #fff;
}

.title-login {
  color: #000;
  text-align: center;
  font-family: "Montserrat", sans-serif;
  font-size: 2.5em;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 5%;
}

.input-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 20px 0;
  outline: none;
}

.input-container input {
  padding: 10px;
  width: 60%;
  box-sizing: border-box;
  height: 3em;
  border: none;
  border-radius: 5px;
  background: #f0f0f0;
  color: #555555;
}

.enviar-button {
  background-color: #ffc737;
  color: white;
  padding: 10px 25px;
  margin-bottom: 20px;
  font-size: 1.2em;
  border: none;
  border-radius: 10px;
  cursor: pointer;
}

.auth-fail {
  color: #ff0000;
  text-align: center;
  font-size: 0.8em;
  margin-bottom: 20px;
}

.bottom-fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 1;
}

@media only screen and (max-width: 992px) {
  .logo img {
    height: 2.5em;
  }

  .site-link {
    font-size: 16px;
  }

  .home-icon {
    width: 0.9em;
    height: 0.9em;
    margin-right: 0.4em;
  }

  .auth-container {
    width: 18em;
  }

  .input-container input {
    width: 70%;
  }

  .title-login {
    font-size: 2em;
  }
}
</style>
